"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_NAME = exports.DATABASE_NAME = void 0;
exports.DATABASE_NAME = 'amplify_logging_cloudwatch';
exports.STORE_NAME = 'logging_cached_logs';
